// import { graphicModule } from './graphics';
import { iconModule } from './icons';
// import { shapeModule } from './shapes';
import { templateModule } from './templates';

import { Module } from 'core/types';

// export const manageModules: Module[] = [shapeModule, iconModule, graphicModule, templateModule];
export const manageModules: Module[] = [iconModule, templateModule];
